import React, { ReactNode } from 'react';
import classNames from 'classnames';

import {
  AvatarGroupAdditionalCountType,
  AvatarGroupType,
  AvatarSizes
} from '../../types';
import Avatar from '../Avatar';

import styles from './styles.module.scss';

interface Props {
  children: ReactNode[];
  additionalCount?: number;
  type?: AvatarGroupType;
  additionalCountSize?: AvatarSizes;
  additionalCountType?: AvatarGroupAdditionalCountType;
  onClick?: () => void;
  secondaryOnClick?: () => void;
}

function AvatarGroup({
  children,
  additionalCount = 0,
  type = AvatarGroupType.Stack,
  additionalCountSize = AvatarSizes.Lg,
  additionalCountType = AvatarGroupAdditionalCountType.None,
  onClick,
  secondaryOnClick
}: Props) {
  return (
    <div
      className={classNames(
        'flex items-center justify-center',
        type === AvatarGroupType.Grid ? 'gap-1' : styles['avatar-group--stack'],
        onClick && 'cursor-pointer'
      )}
      onClick={onClick || undefined}
    >
      {children}
      {additionalCount > 0 && (
        <>
          {additionalCountType === AvatarGroupAdditionalCountType.Clear && (
            <div className="ml-4 mt-[2px] cursor-pointer" onClick={secondaryOnClick}>
              <p className="text-xs font-medium">
                +
                {additionalCount >= 1000
                  ? `${(additionalCount / 1000)
                      .toFixed(1)
                      .replace(/\.0$/, '')}k`
                  : additionalCount}
              </p>
            </div>
          )}

          {additionalCountType === AvatarGroupAdditionalCountType.None && (
            <Avatar
              onClick={secondaryOnClick}
              label={`+${additionalCount}`}
              size={additionalCountSize}
            />
          )}
        </>
      )}
    </div>
  );
}

export default AvatarGroup;
